import { InfoCircleBlackIcon } from '@icons'

import './WarningMessage.scss'

interface Props {
  title: string
  lines?: string[]
}

function WarningMessage({ title, lines }: Props) {
  return (
    <div className='warning-message warning-block'>
      <div className='label'>
        <InfoCircleBlackIcon />
        {title}
      </div>

      {lines?.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
    </div>
  )
}

export default WarningMessage
